<div class="icon {{icon ? ' -icon-'+icon : ''}}"></div>